export class FinalBalanceDue {
    constructor({ payments }) {        
        this.advanceType = 'Advance';
        this.openStatus = 'Open';
        this.completeStatus = 'Completed';
        this.payments = this.sortOrderPayments(payments) ?? [];
    }

    findNextPayment() {
        return this.payments.find((payment) => payment.status === this.openStatus);
    }

    allPaymentsComplete() {
        return this.payments.every((payment) => payment.status === this.completeStatus);
    }

    getIndexOfNextPayment() {
        return this.payments.indexOf(this.findNextPayment());
    }

    mapPaymentInfo() {
        const indexOfNextPayment = this.getIndexOfNextPayment();
        this.payments.map((payment, index) => ({ ...payment, isCurrentPayment: index === indexOfNextPayment }));
    }

    getNextPaymentInfo() {
        const indexOfNextPayment = this.getIndexOfNextPayment();
        return this.payments[indexOfNextPayment];
    }

    getRemainingBalance() {
        const paymentsLeft = this.payments.filter((payment) => payment.status === this.openStatus);
        return paymentsLeft.reduce((acc, el) => Number(el.amount) + acc, 0);
    }

    getPaymentLink(paymentDueInfo) {
        const currentPage = [location.protocol, '//', location.host, location.pathname].join('');
        if (paymentDueInfo?.link) {
            return `${paymentDueInfo?.link}&successURL=${currentPage}&cancelURL=${currentPage}&pendingURL=${currentPage}`;
        }
    }

    sortOrderPayments(payments) {
        return payments
            .filter((payment) => 
                payment.name === this.advanceType &&
                (payment.status === this.openStatus || payment.status === this.completeStatus))
            .sort((a, b) => {
                if (a.status === b.status) { return 0; }
                if (a.status === this.completeStatus) { return -1; }
                return 1;
            });        
    }

    getOrderTabColour({  index, indexOfNextPayment }) {
        if (index < indexOfNextPayment) return 'green';
        if (index === indexOfNextPayment) return 'orange';
        if (index > indexOfNextPayment) return 'white';
        return '';
    }

    build() {
        const paymentDueInfo = this.getNextPaymentInfo();
        return {
            tabColours: this.payments.map((_, index) => this.getOrderTabColour({ index, indexOfNextPayment: this.getIndexOfNextPayment() })),
            paymentDue: Number(paymentDueInfo?.amount),
            remainingBalance: this.getRemainingBalance(),
            ctaLink: this.getPaymentLink(paymentDueInfo),
            isFinalInstalment: this.payments.length === this.getIndexOfNextPayment() + 1,
            allPaymentsComplete: this.allPaymentsComplete(),
        };
    }
}
